import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Silkway from '../assets/img/pictures/silkway.png';
import Trico from '../assets/img/pictures/trico-world.png';

export default function Companies() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const originalImages = [
    'https://www.turkishcargo.com/documents/logolar/yeni_logo/turkish-cargo-logo-395x365.jpg',
    'https://i.pinimg.com/originals/88/45/10/884510a2d764ce27643bcca063c1855e.png',
    Silkway,
    Trico,
    'https://cleanairspaces.com/wp-content/uploads/2021/12/primecargo-logo.png',
  ];

  return (
    <div className="project-area pos-rel de-pt">
      <div className="container">
        <div className="row pt-4 pb-4">
          <div className="col-xl-8 offset-xl-2">
            <div className="site-title text-center mb-20">
              <span className="hero-sub-title mb-20">
                <span className="hero-line"></span>
                Our Global Partnerships
              </span>
              <h2 className="heading-1 mb-0">
                Explore seamless cargo transportation with our trusted partners
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row g-0 filter-active project-page magnific-mix-gallery">
          {originalImages.map((image, index) => (
            <div
              key={index}
              className="col-md-6 col-lg-6 col-xl-3 filter-item cat-1 cat-2 cat-3 p-5"
              data-aos="flip-up"
              data-aos-once="false"
            >
              <div className="project-card image-scale-hover">
                <div className="project-img">
                  <img
                    src={image}
                    alt={`project Image ${index}`}
                    className="pw"
                    data-aos="flip-left"
                    data-aos-once="false"
                    data-aos-hover="flip-up"
                    data-aos-duration="500"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
